import { createSlice } from "@reduxjs/toolkit";
import { getProductFeaturesAPI } from "../../services/getProductFeatures";

const data = {
  isLoading: false,
  error: "",
  message: "",
  data: null,
  statusCode: undefined,
};

const getProductFeaturesSlice = createSlice({
  name: "getProductFeatures",
  initialState: data,
  reducers: {
    getProductFeaturesInfo(state) {
      state.isLoading = true;
    },
    getProductFeaturesInfoSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
      state.message = "";
    },
    getProductFeaturesInfoFailure(state, action) {
      const payload =
        action.payload && typeof action.payload === "object"
          ? action.payload
          : { message: action.payload };
      state.isLoading = false;
      state.message = payload.message ?? "";
      state.statusCode = payload.statusCode;
      state.data = null;
    },
    getProductFeaturesInfoReset(state) {
      state.isLoading = false;
      state.message = "";
      state.data = null;
      state.error = "";
      state.statusCode = undefined;
    },
  },
});

export const getProductFeaturesHandler =
  (data, options = {}) =>
  async (dispatch) => {
  try {
    dispatch(getProductFeaturesAction.getProductFeaturesInfo());
    const response = await getProductFeaturesAPI(data, options);
    dispatch(getProductFeaturesAction.getProductFeaturesInfoSuccess(response));
  } catch (e) {
    const failurePayload =
      e && typeof e === "object" && "message" in e
        ? e
        : { message: e?.response?.data?.message || e || "Something went wrong." };
    dispatch(getProductFeaturesAction.getProductFeaturesInfoFailure(failurePayload));
  }
};
export default getProductFeaturesSlice.reducer;
export const getProductFeaturesAction = getProductFeaturesSlice.actions;
